module.exports = __webpack_public_path__ + "img/contact.e9657cae.svg";